import(/* webpackMode: "eager" */ "/tmpl-test/app/globals.css");
import(/* webpackMode: "eager" */ "/tmpl-test/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/tmpl-test/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/tmpl-test/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/tmpl-test/components/ui/tooltip.tsx")